// Import model
import { SfSectionLine } from '../models/SfSectionLine';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for SfSectionLine - handles JSON serialization and deserialization with type validation
 */
export class SfSectionLineSerializer {
  /**
   * Deserializes a JSON string into a SfSectionLine instance
   */
  static deserialize(json: string): SfSectionLine {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a SfSectionLine instance
   */
  static fromObject(obj: any): SfSectionLine {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to SfSectionLine');
    }


    const instance: SfSectionLine = {
      isDeleted: obj['isDeleted'] as boolean | undefined,
      sku: obj['sku'] as string | undefined,
      sectionExternalId: obj['sectionExternalId'] as string | undefined,
      sectionExternalIdName: obj['sectionExternalId|Name'] as string | undefined,
      quantity: obj['quantity'] as number | undefined,
      description: obj['description'] as string | undefined,
      margin: obj['margin'] as number | undefined,
      cost1: obj['cost1'] as number | undefined,
      wasteFactor: obj['wasteFactor'] as number | undefined,
      taxFactor: obj['taxFactor'] as number | undefined,
      totalTax: obj['totalTax'] as number | undefined,
      totalPrice: obj['totalPrice'] as number | undefined,
      totalCost: obj['totalCost'] as number | undefined,
      unitPrice: obj['unitPrice'] as number | undefined,
      unitCost: obj['unitCost'] as number | undefined,
      isDiscount: obj['isDiscount'] as boolean | undefined,
      itemExternalId: obj['itemExternalId'] as string | undefined,
      itemExternalIdName: obj['itemExternalId|Name'] as string | undefined,
      cost2: obj['cost2'] as number | undefined,
      price1: obj['price1'] as number | undefined,
      price2: obj['price2'] as number | undefined,
      index: obj['index'] as number | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of SfSectionLine instances
   */
  static deserializeArray(json: string): SfSectionLine[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a SfSectionLine instance to a JSON string
   */
  static serialize(instance: SfSectionLine): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a SfSectionLine instance to a plain object
   */
  static toObject(instance: SfSectionLine): any {
    return {
      'isDeleted': instance.isDeleted,
      'sku': instance.sku,
      'sectionExternalId': instance.sectionExternalId,
      'sectionExternalId|Name': instance.sectionExternalIdName,
      'quantity': instance.quantity,
      'description': instance.description,
      'margin': instance.margin,
      'cost1': instance.cost1,
      'wasteFactor': instance.wasteFactor,
      'taxFactor': instance.taxFactor,
      'totalTax': instance.totalTax,
      'totalPrice': instance.totalPrice,
      'totalCost': instance.totalCost,
      'unitPrice': instance.unitPrice,
      'unitCost': instance.unitCost,
      'isDiscount': instance.isDiscount,
      'itemExternalId': instance.itemExternalId,
      'itemExternalId|Name': instance.itemExternalIdName,
      'cost2': instance.cost2,
      'price1': instance.price1,
      'price2': instance.price2,
      'index': instance.index,
    };
  }

  /**
   * Serializes an array of SfSectionLine instances to a JSON string
   */
  static serializeArray(instances: SfSectionLine[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
